/**
 * Register Event Listeners
 * @param  {} elements
 * @param  {} events
 * @param {} func
 */
var registerEventListeners = function registerEventListeners(elements, events, func) {
  Array.from(events).forEach(function (handler, index) {
    Array.from(elements).forEach(function (el, index) {
      el.addEventListener(handler, func);
    });
  });
};

export default registerEventListeners;